import { Skeleton, cn } from "ui";

type PaymentDefaultCardSkeletonProps = {
  className?: string;
};

export const PaymentDefaultCardSkeleton = ({
  className,
}: PaymentDefaultCardSkeletonProps) => (
  <div
    className={cn(
      "rounded-lg border border-foundations-subtle bg-foundations-default p-6",
      className
    )}
  >
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <Skeleton className="h-6 w-9 rounded" />
        <div className="flex flex-col gap-1.5">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-16 rounded-full" />
        </div>
      </div>

      <Skeleton className="h-10 w-full rounded-md" />
    </div>
  </div>
);
